import { render, staticRenderFns } from "./MdWms.vue?vue&type=template&id=96531398&scoped=true&"
import script from "./MdWms.vue?vue&type=script&lang=js&"
export * from "./MdWms.vue?vue&type=script&lang=js&"
import style0 from "./MdWms.vue?vue&type=style&index=0&id=96531398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96531398",
  null
  
)

export default component.exports